import { useId, type ReactNode } from 'react';
import { cn, PaletteUtils } from '@shared/utils';
import styles from './styles.module.css';

type Props = {
  className?: string;
  labelClassName?: string;
  label?: ReactNode;
  readOnly?: boolean;
  value?: boolean;
  onChange?: (value: boolean) => void;
};

export const Checkbox = (props: Props) => {
  const id = useId();

  return (
    <div className={props.className}>
      <input
        id={id}
        className={cn('hidden', styles.checkbox)}
        type='checkbox'
        readOnly={props.readOnly}
        checked={props.value}
        onChange={(e) => (e.stopPropagation(), props.onChange?.(e.target.checked))}
      />
      <label
        htmlFor={id}
        className={cn(
          'flex cursor-pointer select-none items-center gap-2 text-sm font-normal text-slate dark:!text-white',
          styles.label,
          PaletteUtils.isVcfcPalette && styles.vcfc,
          props.readOnly && styles.readonly,
          props.labelClassName,
        )}
      >
        {props.label}
      </label>
    </div>
  );
};
